// TODO: improve it
const TAX_ICON = "https://cdn-icons-png.freepik.com/128/8092/8092267.png";

export enum AlertType {
  SYNC = "sync",
  TAX_CALCULATION = "tax-calculation",
}

export enum ProcessName {
  INITIAL = "Initial",
  END = "End",
}

export enum ProcessStatus {
  INITIAL = "initial",
  PROCESSING = "processing",
  COMPLETED = "completed",
  FAILED = "failed",
}

export class AlertParser {
  id: string | number;
  title: string;
  datetime: string;
  value: string;
  seen: boolean;
  imageUrl: string;
  alertText: string | null;
  href: string | null;

  constructor(alertItem) {
    this.id = alertItem?.id;
    this.title = this.parseTitle(alertItem);
    this.datetime = this.parseDatetime(alertItem);
    this.value = this.parseValue(alertItem);
    this.seen = this.parseSeen(alertItem);
    this.imageUrl = this.parseimageUrl(alertItem);
    this.alertText = this.parseAlertText(alertItem);
    this.href = this.parseAlertHref(alertItem);
  }

  parseTitle(alertItem) {
    const payload = alertItem?.payload;
    let status;
    switch (alertItem?.topic) {
      case AlertType.SYNC:
        if (payload?.step?.name === ProcessName.INITIAL) {
          status = "Started";
        } else if (payload?.status === ProcessStatus.FAILED) {
          status = "Failed";
        } else {
          status = "Succeed";
        }
        return `Sync Process ${status}`;
      case AlertType.TAX_CALCULATION:
        if (payload?.status === "initital") {
          status = "Initial";
        } else if (payload?.status === "failed") {
          status = "Failed";
        } else {
          status = "Succeed";
        }
        return `Tax Calculation ${status}`;

      default:
        return alertItem?.topic;
    }
  }

  parseDatetime(alertItem) {
    const date = new Date(parseInt(alertItem?.timestamp));
    const now = new Date();

    const locale = navigator.language || "en-US"; // get locale to render

    const isSameDay =
      date.getFullYear() === now.getFullYear() &&
      date.getMonth() === now.getMonth() &&
      date.getDate() === now.getDate();

    const isSameYear = date.getFullYear() === now.getFullYear();

    if (isSameDay) {
      return date.toLocaleTimeString(locale, {
        hour: "2-digit",
        minute: "2-digit",
      });
    } else if (isSameYear) {
      return date.toLocaleDateString(locale, {
        day: "2-digit",
        month: "2-digit",
      });
    } else {
      return date.toLocaleDateString(locale, {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    }
  }

  parseValue(alertItem) {
    const payload = alertItem?.payload;
    switch (alertItem?.topic) {
      case AlertType.SYNC:
        if (payload?.step?.name === ProcessName.INITIAL) {
          return `The synchronization process of ${
            alertItem?.apiKey?.exchange?.name
          } with key ${(alertItem?.apiKey?.key || "").slice(0, 5)}... has initial`;
        } else if (payload?.status === ProcessStatus.FAILED) {
          return `The synchronization process of ${
            alertItem?.apiKey?.exchange?.name
          } with key ${(alertItem?.apiKey?.key || "").slice(
            0,
            5
          )}... failed. Please try again.`;
        } else {
          return `The synchronization process of ${
            alertItem?.apiKey?.exchange?.name
          } with key ${(alertItem?.apiKey?.key || "").slice(
            0,
            5
          )}... completed successfully.`;
        }
      case AlertType.TAX_CALCULATION:
        if (payload?.step?.name === ProcessName.INITIAL) {
          return `The tax calculation process has initial`;
        } else if (payload?.status === ProcessStatus.FAILED) {
          return `The tax calculation process failed. Please try again.`;
        } else {
          return `The tax calculation process completed successfully.`;
        }
      default:
        return "";
    }
  }

  parseAlertText(alertItem) {
    const topic = alertItem?.topic || alertItem?.type;
    switch (topic) {
      case AlertType.SYNC:
        return `Sync process of ${alertItem?.apiKey?.exchange?.name} at ${alertItem?.step?.name} ${alertItem?.status}`;
      case AlertType.TAX_CALCULATION:
        return `Tax Calculation at ${alertItem?.step?.name} ${alertItem?.status}`;
      default:
        return null;
    }
  }
  parseSeen(alertItem) {
    return alertItem?.seen;
  }

  parseimageUrl(alertItem) {
    switch (alertItem?.topic) {
      case AlertType.SYNC:
        return alertItem?.apiKey?.exchange?.imageUrl;
      case AlertType.TAX_CALCULATION:
        return TAX_ICON;
      default:
        return null;
    }
  }
  parseAlertHref(alertItem){
    switch (alertItem?.topic) {
      case AlertType.SYNC:
        return `/integration/${alertItem?.apiKey?.exchange?.id?.toLowerCase()}`
      case AlertType.TAX_CALCULATION:
        return "/tax/cgt";
      default:
        return null;
    }
  }
}
